import { connect } from 'react-redux';
import CateringTaskReport from './CateringTaskReport';
import { getOrganizationMembersList } from '../../Projects/projectsActions';
import { getTaskLocation } from '../tasksActions';
import { getCateringTasksList } from './cateringTaskReportActions';

const mapStateToProps = (state) => ({
    selectedOrganization: state.organization.selectedOrganization,
    orgMembersList: state.project.orgMembersList,
    locationsList: state.task.locationsList,
    cateringTasksList: state.cateringTaskReport.cateringTasksList,
    isLoading: state.cateringTaskReport.isLoading,
    totalTasksCount: state.cateringTaskReport.cateringTasksListCount,
    pageSize: state.cateringTaskReport.cateringTaskPageSize,
});

const mapDispatchToProps = (dispatch) => ({
    getOrganizationMembersList: (payload) => dispatch(getOrganizationMembersList(payload)),
    getTaskLocation: (payload) => dispatch(getTaskLocation(payload)),
    getCateringTasksList: (payload) => dispatch(getCateringTasksList(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CateringTaskReport);
